import { useState, useEffect } from "react";
// --------------------- Import Services ---------------------
import { buscarApartamentosService } from "../services/buscarApartamentosService";

// --------------------- Import Interfaces ---------------------
import { Apartamento } from "../../../interfaces/Apartamento";

export const useApartamentos = () => {
  const [apartamentos, setApartamentos] = useState<Apartamento[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  // UseEffect necessário para buscar as assinaturas
  useEffect(() => {
    const fetchAssinaturas = async () => {
      const data = await buscarApartamentosService();

      setApartamentos(data);
      setIsLoading(false);
    };

    fetchAssinaturas();
  }, []);

  return { apartamentos, isLoading };
};
